import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import confetti from 'canvas-confetti';

const Navbar = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const triggerConfetti = () => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { x: 0.5, y: 0.5 },
      colors: ['#c4bdaa', '#f5ecd8', '#d2b48c', '#a18d72'],
    });
  };

  useEffect(() => {
    const closeMenuOnClickOutside = (e) => {
      if (!e.target.closest('.navbar') && isOpen) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', closeMenuOnClickOutside);
    return () => {
      document.removeEventListener('click', closeMenuOnClickOutside);
    };
  }, [isOpen]);

  return (
    <nav className="navbar">
      {/* Right Side: Menu & Events */}
      <div className="nav-links nav-right">
        <Link to="/events">{t('events')}</Link>
        <Link to="/menu">{t('menu')}</Link>
      </div>

      {/* Center: Logo */}
      <div className="logo-container">
        <img
          src="/images/BarkatzeLogo.png"
          alt="Pub Logo"
          className="logo"
          onClick={triggerConfetti}
        />
      </div>

      {/* Left Side: About & Gallery */}
        <div className="nav-links nav-left">
        <Link to="/gallery">{t('gallery')}</Link>
        <Link to="/">{t('about')}</Link>
      </div>
      

      {/* Hamburger Menu Button (Shown on Mobile) */}
      <div className="hamburger" onClick={toggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>

      {/* Hamburger Menu */}
      {isOpen && (
        <div className="hamburger-menu">
          <Link to="/" onClick={toggleMenu}>
            {t('about')}
          </Link>
          <Link to="/gallery" onClick={toggleMenu}>
            {t('gallery')}
          </Link>
          <Link to="/menu" onClick={toggleMenu}>
            {t('menu')}
          </Link>
          <Link to="/events" onClick={toggleMenu}>
            {t('events')}
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
